import React from 'react'
import { useNavigate } from 'react-router-dom'

const PageNotFound = () => {
    const navigate = useNavigate()

    const handleGoToDashboard = () => {
        navigate('/')
    }

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        backgroundColor: '#f8f9fa', padding: '20px', textAlign: 'center', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
            <div style={{ maxWidth: '600px', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.08)', padding: '50px 30px', margin: '0 auto' }}>
                {/* 404 Badge */}
                <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '80px', height: '80px', backgroundColor: '#e9ecef', borderRadius: '50%', marginBottom: '24px', fontSize: '32px', fontWeight: 'bold', color: '#495057' }}>
                    404
                </div>

                <h1 style={{ fontSize: '36px', fontWeight: '700', color: '#343a40', marginBottom: '16px' }}>
                    Page Not Found
                </h1>

                <p style={{ fontSize: '18px', color: '#6c757d', lineHeight: '1.6', marginBottom: '32px' }}>
                    The page you're looking for doesn't exist or has been moved.
                </p>

                {/* Primary Button */}
                <button onClick={handleGoToDashboard} style={{ backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '8px', padding: '12px 32px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease', boxShadow: '0 4px 6px rgba(40, 167, 69, 0.25)' }}
                    onMouseEnter={(e) => {
                        const btn = e.currentTarget
                        btn.style.backgroundColor = '#218838'
                        btn.style.transform = 'translateY(-2px)'
                    }}
                    onMouseLeave={(e) => {
                        const btn = e.currentTarget
                        btn.style.backgroundColor = '#28a745'
                        btn.style.transform = 'translateY(0)'
                    }}
                >
                    🏠 Back to Dashboard
                </button>

                {/* Secondary Link */}
                <div style={{ marginTop: '24px' }}>
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#0d6efd',
                            fontSize: '15px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            padding: '8px 16px',
                            textDecoration: 'underline'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'none'}
                        onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'underline'}
                    >
                        ← Or go back to previous page
                    </button>
                </div>
            </div>
        </div>
    )
}

export default PageNotFound